import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/menu-icons/dashboard/shortage_qty.png'
import _imports_1 from '../../assets/menu-icons/dashboard/expiries.png'
import _imports_2 from '../../assets/menu-icons/dashboard/near_expiry.png'
import _imports_3 from '../../assets/menu-icons/dashboard/average_bill_value.png'


const _withScopeId = n => (_pushScopeId("data-v-a5ba2ffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-m-2" }
const _hoisted_2 = { class: "p-grid tile-justify" }
const _hoisted_3 = {
  key: 0,
  class: "p-sm-6 p-lg-2 p-md-3",
  style: {"padding-right":"0 !important"}
}
const _hoisted_4 = { class: "card-body p-p-2 card-styles" }
const _hoisted_5 = { style: {"float":"left","width":"60%"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, " Shortage Quantity ", -1))
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "mt-2 p-mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Products that need restocking", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_11 = {
  key: 1,
  class: "p-sm-6 p-lg-2 p-md-3",
  style: {"padding-right":"0 !important"}
}
const _hoisted_12 = { class: "card-body p-p-2 card-styles" }
const _hoisted_13 = { style: {"float":"left","width":"60%"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Expired Products ", -1))
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "mt-2 p-mb-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Total expired products in inventory", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_19 = {
  key: 2,
  class: "p-sm-6 p-lg-2 p-md-3",
  style: {"padding-right":"0 !important"}
}
const _hoisted_20 = { class: "card-body p-p-2 card-styles" }
const _hoisted_21 = { style: {"float":"left","width":"60%"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Upcoming Expiries ", -1))
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "mt-2 p-mb-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Products that will expire soon", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_27 = {
  key: 3,
  class: "p-sm-6 p-lg-2 p-md-3",
  style: {"padding-right":"0 !important"}
}
const _hoisted_28 = { class: "card-body p-p-2 card-styles" }
const _hoisted_29 = { style: {"float":"left","width":"60%"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Pay Later Balance ", -1))
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "mt-2 p-mb-2" }
const _hoisted_33 = { style: {"font-size":"medium"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Outstanding balance from customers ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_36 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_37 = { class: "p-col-12" }
const _hoisted_38 = { class: "card" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " Sales, Sales Refund, Purchase, Purchase Returns, Stock Loss, Stock Transfer Out, Stock Transfer In (Last 30 days) ")
], -1))
const _hoisted_40 = { class: "card-body p-p-1" }
const _hoisted_41 = {
  key: 1,
  class: "p-grid p-justify-center p-align-start"
}
const _hoisted_42 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " SALES TODAY ", -1))
const _hoisted_44 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_45 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " RETURNS TODAY ", -1))
const _hoisted_47 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_48 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET SALES TODAY ", -1))
const _hoisted_50 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_51 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " SALES MONTH ", -1))
const _hoisted_53 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_54 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " RETURNS MONTH ", -1))
const _hoisted_56 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_57 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET SALES MONTH ", -1))
const _hoisted_59 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_60 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASES TODAY ", -1))
const _hoisted_62 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_63 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASES RETURN TODAY ", -1))
const _hoisted_65 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_66 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET PURCHASES TODAY ", -1))
const _hoisted_68 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_69 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASES MONTH ", -1))
const _hoisted_71 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_72 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASES RETURN MONTH ", -1))
const _hoisted_74 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_75 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET PURCHASES MONTH ", -1))
const _hoisted_77 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_78 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " STOCK TRANSFER IN TODAY ", -1))
const _hoisted_80 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_81 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " STOCK TRANSFER OUT TODAY ", -1))
const _hoisted_83 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_84 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET STOCK TRANSFER TODAY ", -1))
const _hoisted_86 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_87 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " STOCK TRANSFER IN MONTH ", -1))
const _hoisted_89 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_90 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " STOCK TRANSFER OUT MONTH ", -1))
const _hoisted_92 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_93 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET STOCK TRANSFER MONTH ", -1))
const _hoisted_95 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_96 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " STOCK LOSS TODAY ", -1))
const _hoisted_98 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_99 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " STOCK LOSS MONTH ", -1))
const _hoisted_101 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_102 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left","visibility":"hidden"}
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " STOCK LOSS MONTH ", -1))
const _hoisted_104 = { class: "p-d-flex p-jc-between card-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (this.can('stock_alert_report'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "card hover-settings",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToStockAlertReport && _ctx.navigateToStockAlertReport(...args))),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h4", _hoisted_8, " # " + _toDisplayString(_ctx.dashInfo.shortageQty), 1),
                    _hoisted_9
                  ])
                ]),
                _hoisted_10
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.can('stock_expiry_report'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "card hover-settings",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToExpiryReport && _ctx.navigateToExpiryReport(...args))),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h4", _hoisted_16, " # " + _toDisplayString(_ctx.dashInfo.expired), 1),
                    _hoisted_17
                  ])
                ]),
                _hoisted_18
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.can('stock_near_expiry_report'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "card hover-settings",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToNearExpiryReport && _ctx.navigateToNearExpiryReport(...args))),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("h4", _hoisted_24, " # " + _toDisplayString(_ctx.dashInfo.upcomingExpiry), 1),
                    _hoisted_25
                  ])
                ]),
                _hoisted_26
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.can('transaction_receipt'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", {
              class: "card hover-settings",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navigatePayLater && _ctx.navigatePayLater(...args))),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("h4", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, "(" + _toDisplayString(_ctx.currency) + ") ", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.dashInfo.payLaterBalance.toFixed(2)), 1)
                    ]),
                    _hoisted_34
                  ])
                ]),
                _hoisted_35
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.can('dashboard_revenue_graph'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_Chart, {
                  type: "line",
                  data: _ctx.multiAxisData,
                  options: _ctx.multiAxisOptions,
                  height: 75
                }, null, 8, ["data", "options"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('dashboard_sales_today'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_43
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.salesToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_46
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.returnToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_49
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                        _ctx.dashInfo.salesToday -
                                            _ctx.dashInfo.returnToday
                                    )), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_52
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.salesMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_55
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.returnMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_58
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                        _ctx.dashInfo.salesMonth -
                                            _ctx.dashInfo.returnMonth
                                    )), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_61
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_64
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseReturnToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_67
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                        _ctx.dashInfo.purchaseToday -
                                            _ctx.dashInfo.purchaseReturnToday
                                    )), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_70
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_73
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseReturnMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_76
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                        _ctx.dashInfo.purchaseMonth -
                                            _ctx.dashInfo.purchaseReturnMonth
                                    )), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_79
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.stockTransferInToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_82
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.stockTransferOutToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_84, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_85
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.netStockTransferToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_88
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.stockTransferInMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_90, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_91
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.stockTransferOutMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_94
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.netStockTransferMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_96, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_97
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.stockLossToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_100
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.stockLossMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_102, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_103
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.stockLossMonth)), 1)
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}